import type { CandidateVacancy } from '../types';

type CandidateRole = NonNullable<CandidateVacancy['responsibleUser']>['role'];

export function mockCandidateRole(
  overrides: Partial<CandidateRole> = {}
): CandidateRole {
  return {
    id: 1,
    name: 'manager',
    displayName: 'Manager',
    permissions: ['vacancy.read', 'vacancy.write'],
    ...overrides,
  };
}
